import { CLEAR_BOTS_STORE } from './bot'
import { CLEAR_SETTINGS_WEBCHAT_STORE } from './settingsWebchat'
import { CLEAR_SOCKETIO_STORE } from './socketIO'

export const cleanStorage = ({ commit }) => {
  const mutations = [
    CLEAR_BOTS_STORE,
    CLEAR_SOCKETIO_STORE,
    CLEAR_SETTINGS_WEBCHAT_STORE
  ]

  mutations.map(mutation => commit(mutation))
}
